export function spendingReducer(state = {
    ADMIN: {},
    USER: {},
},{
    type,
    payload
}){
    
    switch(type){
        case "NEW_SPENDING":            
            let list = Object.assign({}, state);
            list.USER[payload.spending_id] = payload
            list.ADMIN[payload.spending_id] = payload
            
            return list
        case "UPDATE_SPENDING":            
        case "UPDATE_FETCH_SPENDING":            
            let list2 = {}
            list2.ADMIN = Object.assign({}, state.ADMIN);
            list2.USER = Object.assign({}, state.USER);
            const {userID, data} = payload;
            
            if(userID === data.spending_user){
                list2.USER[data.spending_id] = data
            }

            list2.ADMIN[data.spending_id] = data
            
            return list2
            
        case "DELETE_SPENDING":            
            let list5 = Object.assign({}, state);
            
            if(payload.userID === payload.data.spending_user){
                delete list5.USER[payload.data.spending_id]
            }

            delete list5.ADMIN[payload.data.spending_id]
            
            return list5
            
        case "GET_USER_SPENDINGS":
            let list3 = Object.assign({}, state);
            list3.USER = payload
            return list3

        case "GET_ADMIN_SPENDINGS":
            let list4 = Object.assign({}, state);
            list4.ADMIN = payload
            return list4
            
        case "GET_SPENDING_PAYMENTS":          
            let list6 = Object.assign({}, state);
            list6.ADMIN[payload.spendingID].spending_payments = payload.payments
            return list6
        case "ADD_SPENDING_TO_PROJECT":          
            let list7 = Object.assign({}, state);
            payload.list.forEach(spending => {
                let tab = list7.ADMIN[spending].spending_project.split()
                if ( !tab.includes(payload.project_id)) {
                    tab.push(payload.project_id)
                }
                list7.ADMIN[spending].spending_project = tab.join(", ")
            });
            return list7

        default:
            return state;
    }
    
}